import { Alert, Container } from "reactstrap";
import styled from "styled-components";

export const BootstrapContainer = styled(Container)`
  position: relative;
`;

export const BootstrapAlert = styled(Alert)`
  z-index: 100;
  //max-width: 60%;
  //height: 100px;
  //width: 100%
`;
